// Registry i18n messages - Russian
// This file contains common messages shared across all registry components
// Module-specific messages (auth, logs, settings, user) are in their respective modules
// To use module translations, import and merge them in your project's i18n config
// Example: import { authRu } from '@/modules/auth/i18n'

export default {
  common: {
    welcome: 'Добро пожаловать',
    loading: 'Загрузка...',
    error: 'Ошибка',
    success: 'Успех',
    cancel: 'Отмена',
    save: 'Сохранить',
    create: 'Создать',
    delete: 'Удалить',
    edit: 'Редактировать',
    preview: 'Предпросмотр',
    close: 'Закрыть',
    confirm: 'Подтвердить',
    search: 'Поиск',
    refresh: 'Обновить',
    refreshed: 'Обновлено',
    filter: 'Фильтр',
    sort: 'Сортировать',
    actions: 'Действия',
    yes: 'Да',
    no: 'Нет',
    previous: 'Предыдущий',
    next: 'Следующий',
    columns: 'Столбцы',
    open_menu: 'Открыть меню',
    back: 'Назад',
    done: 'Готово',
    never: 'Никогда',
    or: 'или',
    created: 'Создано',
    updated: 'Обновлено',
    toggleSidebar: 'Переключить боковую панель',
    toggleDarkMode: 'Переключить на {mode} режим',
    darkMode: 'тёмный',
    lightMode: 'светлый',
    toggleLanguage: 'Переключить язык на {locale}',
    copyToClipboard: {
      success: 'Скопировано в буфер обмена',
      copied: 'Скопировано',
      copy: 'Копировать',
    },
    pagination: {
      totalRows: 'Всего {total} строк(и)',
      rowsPerPage: 'Строк на страницу',
      rowsPerPageValue: 'Строк на страницу: {count}',
      page: 'Страница',
      of: 'из',
      goToFirstPage: 'Перейти на первую страницу',
      goToPreviousPage: 'Перейти на предыдущую страницу',
      goToNextPage: 'Перейти на следующую страницу',
      goToLastPage: 'Перейти на последнюю страницу',
    },
    pages: {
      landing: 'Главная',
      cookies: 'Cookies',
      privacy: 'Политика конфиденциальности',
      terms: 'Условия использования',
      contact: 'Контакты',
      about: 'О приложении',
      aiContext: 'Контекст AI',
      notFound: 'Страница не найдена',
    },
  },
  markdown: {
    supported: 'Markdown поддерживается',
    supportedHint: 'Вы можете использовать markdown для форматирования текста. Поддерживаемые функции: заголовки, жирный, курсив, списки, ссылки, изображения, блоки кода, таблицы, цитаты и многое другое.',
    showingPreview: 'Показ предпросмотра',
    linkSecurity: {
      linkTooLong: 'Ссылка слишком длинная и была заблокирована',
      dangerousProtocolBlocked: 'Опасный протокол был заблокирован',
    },
  },
  validation: {
    required: 'Это поле обязательно',
    email: 'Неверный адрес электронной почты',
    min: 'Должно быть не менее {min} символов',
    min_length: 'Должно быть не менее {min} символов',
    max: 'Должно быть не более {max} символов',
    password_mismatch: 'Пароли не совпадают',
    password_too_short: 'Пароль должен быть не менее {min} символов',
    invalid_token: 'Неверный или истёкший токен',
  },
  errors: {
    generic: 'Произошла ошибка. Пожалуйста, попробуйте снова',
    network: 'Ошибка сети. Проверьте подключение',
    unauthorized: 'У вас нет прав для выполнения этого действия',
    not_found: 'Ресурс не найден',
    server_error: 'Ошибка сервера. Пожалуйста, попробуйте позже',
    chunkLoadError: {
      title: 'Доступна новая версия',
      message: 'Доступна новая версия приложения. Страницу необходимо перезагрузить для продолжения.',
      description: 'Пожалуйста, сохраните свою работу перед перезагрузкой.',
      reload: 'Перезагрузить страницу',
      cancel: 'Отмена',
    },
  },
  navigation: {
    main: 'Навигация',
    dashboard: 'Панель управления',
    profile: 'Профиль',
    settings: 'Настройки',
    myGear: 'Собрания',
    public: 'Публичное',
  },
  footer: {
    cookies: 'Информация о cookies',
    privacy: 'Политика конфиденциальности',
    terms: 'Условия использования',
    contact: 'Контакты',
    github: 'GitHub',
    recaptcha: {
      notice: 'Этот сайт защищён reCAPTCHA. Применяются',
      privacy: 'Политика конфиденциальности',
      and: ' и ',
      terms: 'Условия использования',
      google: ' Google.',
    },
  },
  cookies: {
    title: 'Информация о cookies',
    subtitle: 'Информация об использовании данных в приложении',
    whatAre: {
      title: 'Что такое cookies',
      description: 'Cookies — это небольшие текстовые файлы, которые сохраняются на вашем устройстве при просмотре веб-сайта. Они помогают приложению запоминать ваши предпочтения и обеспечивать базовую функциональность.',
    },
    types: {
      title: 'Типы cookies, которые мы используем',
      essential: {
        title: 'Необходимые cookies',
        description: 'Эти cookies необходимы для работы приложения и не могут быть отключены. Мы используем их для:',
        items: {
          session: 'Поддержания пользовательской сессии после входа (JWT токен)',
          security: 'Целей безопасности (защита от CSRF атак)',
          preferences: 'Запоминания основных предпочтений (язык, тёмный режим)',
        },
      },
      functional: {
        title: 'Функциональные cookies',
        description: 'Эти cookies помогают приложению работать лучше и запоминать ваши выборы:',
        items: {
          settings: 'Настройки приложения, хранящиеся локально (localStorage)',
          preferences: 'Предпочтения отображения и макет интерфейса',
        },
      },
    },
    localStorage: {
      title: 'LocalStorage',
      description: 'В дополнение к cookies, приложение также использует localStorage браузера для локального хранения некоторых данных на вашем устройстве, таких как:',
      items: {
        settings: 'Настройки приложения (предпочтения языка, единицы веса)',
        cache: 'Временные кэш-данные для улучшения производительности',
        offline: 'Офлайн-данные для работы без интернет-соединения',
      },
    },
    management: {
      title: 'Управление cookies',
      description: 'Вы можете управлять cookies несколькими способами:',
      items: {
        browser: 'Через настройки браузера — большинство браузеров позволяют просматривать и удалять cookies',
        block: 'Блокировка определённых типов cookies (может повлиять на функциональность приложения)',
        delete: 'Удаление cookies — вы можете удалить их в любое время, но это потребует повторного входа',
      },
      note: 'Примечание: Отключение необходимых cookies может привести к тому, что некоторые функции приложения перестанут работать должным образом.',
    },
    thirdParty: {
      title: 'Сторонние cookies',
      description: 'Приложение может использовать внешние сервисы (например, Google Analytics, reCAPTCHA), которые могут размещать свои собственные cookies. В соответствии с нашей политикой конфиденциальности, мы информируем об использовании таких сервисов и обеспечиваем соответствующую защиту данных.',
    },
    privacy: {
      title: 'Конфиденциальность',
      description: 'Все cookies, используемые приложением, служат исключительно для обеспечения функциональности сервиса. Мы не используем cookies для отслеживания пользователей в маркетинговых целях или для передачи личных данных третьим лицам без вашего согласия.',
    },
    rodo: {
      title: 'GDPR',
      description: 'В соответствии с Общим регламентом по защите данных (GDPR), необходимые cookies не требуют вашего согласия, так как они необходимы для работы сервиса. Для других cookies мы запросим ваше согласие, если это потребуется.',
    },
  },
  privacy: {
    title: 'Политика конфиденциальности',
    subtitle: 'Как мы защищаем ваши данные',
    dataCollection: {
      title: 'Сбор данных',
      description: 'Приложение Zbory CHWZ собирает следующие данные:',
      items: {
        account: 'Данные учётной записи: email, полное имя (необходимы для создания учётной записи)',
        congregations: 'Данные о собраниях: названия, адреса, время богослужений, контактные лица (хранятся в базе данных)',
        settings: 'Настройки приложения: языковые предпочтения, тема, другие настройки',
        usage: 'Данные об использовании: журналы доступа, действия, выполненные в приложении (для целей безопасности и улучшения сервиса)',
      },
    },
    dataStorage: {
      title: 'Хранение данных',
      description: 'Контактные данные зборов (имена и фамилии контактных лиц, телефоны, адреса электронной почты) и адреса зборов шифруются в нашей базе данных. Мы также используем стандартные практики безопасности: хеширование паролей, шифрование соединений (HTTPS) и регулярное резервное копирование данных.',
    },
    dataAccess: {
      title: 'Доступ к данным',
      description: 'Ваши данные доступны только вам и защищены паролем. Наши администраторы имеют технический доступ к данным исключительно для целей обслуживания и улучшения сервиса, в соответствии с лучшими практиками безопасности.',
      thirdParties: 'Мы не передаём ваши личные данные третьим лицам, за исключением случаев, требуемых законом или с вашего явного согласия.',
      aiProcessing: 'Исключением является функция автоматического импорта обновлений данных збора из писем от духовенства: ограниченная часть содержимого такого письма передаётся внешнему поставщику ИИ исключительно для извлечения и предварительной проверки предлагаемых изменений. При этом мы не передаём имя распознанного отправителя и предыдущие (до изменения) значения контактных данных.',
    },
    oauth: {
      title: 'OAuth аутентификация',
      description: 'Мы предлагаем возможность входа с использованием внешних OAuth провайдеров (Google, Facebook). При использовании этой функции:',
      items: {
        receive: 'Мы получаем базовую информацию из вашей учётной записи (email, имя, фотография профиля)',
        store: 'Мы храним только необходимые данные для предоставления сервиса',
        share: 'Мы не передаём ваши данные обратно OAuth провайдерам без вашего согласия',
        revoke: 'Вы можете отозвать доступ к своей учётной записи в любое время в настройках OAuth провайдера',
      },
      policies: 'Используя OAuth, вы также принимаете политику конфиденциальности соответствующего провайдера (Google или Facebook).',
    },
    dataDeletion: {
      title: 'Удаление данных',
      description: 'Вы имеете полный контроль над своими данными и можете удалить их в любое время. Чтобы удалить свою учётную запись и все связанные данные:',
      steps: {
        settings: 'Перейдите в настройки приложения',
        delete: 'Найдите раздел "Удалить учётную запись"',
        confirm: 'Введите "DELETE" в поле подтверждения и подтвердите удаление',
      },
      alternative: 'Альтернативно, вы можете связаться с нами по адресу',
      request: 'и запросить удаление учётной записи.',
      retention: 'После удаления учётной записи ваши данные удаляются из наших систем в течение 30 дней. Некоторые данные могут храниться дольше, если это требуется по закону или для разрешения споров.',
      oauth: 'Если вы используете OAuth вход, вы также должны отозвать доступ к приложению в настройках учётной записи OAuth провайдера (Google/Facebook).',
    },
    userRights: {
      title: 'Ваши права',
      description: 'В соответствии с GDPR, вы имеете право:',
      access: 'Получать доступ к своим личным данным',
      rectification: 'Проверять и исправлять свои данные',
      erasure: 'Удалять свои данные ("право на забвение")',
      portability: 'Передавать свои данные в другой сервис',
      object: 'Возражать против обработки данных',
      contact: 'Чтобы воспользоваться любым из этих прав, пожалуйста, свяжитесь с нами по адресу',
    },
    cookies: {
      title: 'Cookies',
      description: 'Приложение использует cookies для поддержания пользовательских сессий и улучшения функциональности. Более подробная информация об использовании cookies доступна на странице',
      link: 'Информация о cookies',
    },
    changes: {
      title: 'Изменения в политике',
      description: 'В случае значительных изменений в способе обработки данных, эта страница будет обновлена, и пользователи будут уведомлены об изменениях по электронной почте или уведомлением в приложении. Продолжение использования приложения после изменений означает принятие обновлённой политики конфиденциальности.',
    },
    contact: {
      title: 'Контакты',
      description: 'По вопросам политики конфиденциальности или обработки данных, пожалуйста, свяжитесь:',
    },
  },
  terms: {
    title: 'Условия использования',
    subtitle: 'Условия и правила использования сервиса',
    acceptance: {
      title: 'Принятие условий',
      description: 'Используя приложение Zbory CHWZ, вы принимаете эти условия использования. Если вы не согласны с какими-либо из следующих условий, вы не должны использовать сервис.',
    },
    account: {
      title: 'Пользовательская учётная запись',
      description: 'Для использования некоторых функций приложения вы должны создать учётную запись. Вы соглашаетесь:',
      responsibilities: {
        provide: 'Предоставлять правдивую и актуальную информацию при регистрации',
        maintain: 'Поддерживать безопасность своей учётной записи и пароля',
        notify: 'Немедленно уведомлять нас о любом несанкционированном использовании вашей учётной записи',
        responsible: 'Нести ответственность за все действия, выполненные с использованием вашей учётной записи',
      },
    },
    oauth: {
      title: 'OAuth аутентификация',
      description: 'Приложение позволяет входить с использованием внешних OAuth провайдеров (например, Google, Facebook). При использовании этой функции:',
      rules: {
        provider: 'Вы принимаете условия использования и политику конфиденциальности OAuth провайдера',
        data: 'Вы соглашаетесь на передачу базовой информации из вашей учётной записи нам (email, имя, фотография профиля)',
        revoke: 'Вы можете отозвать доступ к своей учётной записи в любое время в настройках OAuth провайдера',
      },
    },
    content: {
      title: 'Пользовательский контент',
      description: 'Пользователь сохраняет все права на контент, который он создаёт и хранит в приложении. Пользователь предоставляет нам только необходимую лицензию для хранения, отображения и обработки этих данных для предоставления сервиса.',
    },
    prohibited: {
      title: 'Запрещённые действия',
      description: 'Запрещается следующее:',
      items: {
        illegal: 'Использование приложения в незаконных целях',
        harmful: 'Передача вредоносного, оскорбительного или незаконного контента',
        access: 'Попытки несанкционированного доступа к системе или другим учётным записям пользователей',
        disrupt: 'Нарушение работы приложения или серверов',
        impersonate: 'Выдача себя за другое лицо или притворство кем-то другим',
      },
    },
    termination: {
      title: 'Прекращение учётной записи',
      description: 'Мы оставляем за собой право приостановить или удалить вашу учётную запись в случае нарушения этих условий или по другим важным причинам. Вы также можете удалить свою учётную запись в любое время в настройках приложения.',
    },
    disclaimer: {
      title: 'Отказ от ответственности',
      description: 'Приложение предоставляется "как есть" без каких-либо гарантий. Мы не несём ответственности за любой ущерб, возникший в результате использования приложения.',
    },
    changes: {
      title: 'Изменения условий',
      description: 'Мы оставляем за собой право вносить изменения в эти условия. Пользователи будут уведомлены о значительных изменениях. Продолжение использования приложения после изменений означает принятие новых условий.',
    },
    contact: {
      title: 'Контакты',
      description: 'По вопросам об этих условиях, пожалуйста, свяжитесь с нами, используя контактную форму, доступную в приложении.',
    },
  },
  contact: {
    title: 'Контакты',
    subtitle: 'Свяжитесь с нами',
    info: {
      title: 'Контактная информация',
      description: 'Если у вас есть вопросы, предложения или вы хотите сообщить о проблеме, пожалуйста, свяжитесь с нами:',
    },
    email: {
      label: 'Email',
    },
    support: {
      title: 'Поддержка',
      description: 'Мы стараемся отвечать на все сообщения в течение 7 дней. Если вы сообщаете о технической проблеме, пожалуйста, включите подробную информацию о проблеме.',
    },
  },
  landing: {
    title: 'Zbory CHWZ',
    subtitle: 'Управляйте и публикуйте данные о собраниях Христианской Пятидесятнической Общины',
    welcomeBack: 'С возвращением, {name}!',
    feature1: {
      title: 'Каталог',
      description: 'Просматривайте список собраний с основной информацией',
    },
    feature2: {
      title: 'Детали',
      description: 'Адреса, время богослужений и контактные лица',
    },
    feature3: {
      title: 'Публикация',
      description: 'Публикуйте проверенные профили собраний',
    },
    login: 'Войти',
    register: 'Регистрация',
    footer: 'Начните управлять данными собраний сегодня',
    localData: {
      title: 'У вас есть данные в браузере',
      description: 'Войдите или зарегистрируйтесь для синхронизации данных',
    },
    stats: {
      totalUsers: 'Всего пользователей',
      totalContainers: 'Всего собраний',
      totalItems: 'Всего записей',
      newThisMonth: 'в этом месяце',
    },
  },
  notFound: {
    title: 'Страница не найдена',
    description: 'Страница, которую вы ищете, не существует.',
    suggestions: 'Вот несколько полезных ссылок:',
    goToCongregations: 'Перейти к собраниям',
    goToDashboard: 'Перейти к панели управления',
    goToSettings: 'Перейти к настройкам',
  },
  pwa: {
    update: {
      title: 'Доступна новая версия',
      description: 'Доступна новая версия приложения. Хотите обновить сейчас?',
      reload: 'Обновить сейчас',
      later: 'Позже',
    },
  },
  fileUpload: {
    dropZone: {
      idle: 'Нажмите для загрузки или перетащите файлы',
      dragging: 'Отпустите файлы здесь',
      disabled: 'Загрузка отключена',
    },
    formats: {
      image: 'JPEG, PNG, WEBP, GIF',
      any: 'Любой тип файла',
    },
    limits: {
      maxSize: 'макс. {size} МБ',
      maxFiles: '{count} файлов',
      maxFile: '{count} файл',
    },
    errors: {
      tooManyFiles: 'Максимум {max} файл(ов) разрешено',
      fileTooLarge: '{name}: Размер файла превышает {size} МБ',
      invalidType: '{name}: Неверный тип файла',
    },
    imageGallery: {
      title: 'Изображения',
      noImages: 'Изображения ещё не загружены',
      primary: 'Основное',
      tooltips: {
        setPrimary: 'Установить как основное',
        dragToReorder: 'Перетащите для изменения порядка',
        deleteImage: 'Удалить изображение',
      },
      confirmDelete: 'Вы уверены, что хотите удалить это изображение?',
      messages: {
        loadFailed: 'Не удалось загрузить изображения',
        uploadSuccess: 'Изображение успешно загружено',
        uploadSuccessMultiple: '{count} изображений успешно загружено',
        uploadFailed: 'Не удалось загрузить изображение',
        deleteSuccess: 'Изображение успешно удалено',
        deleteFailed: 'Не удалось удалить изображение',
        primarySuccess: 'Основное изображение обновлено',
        primaryFailed: 'Не удалось установить основное изображение',
        reorderSuccess: 'Изображения переупорядочены',
        reorderFailed: 'Не удалось переупорядочить изображения',
      },
    },
  },
  about: {
    title: 'О Zbory CHWZ',
    subtitle: 'Приложение для управления и публичной презентации собраний Христианской Пятидесятнической Общины',
    tableOfContents: {
      title: 'Содержание',
    },
    overview: {
      title: 'Обзор',
      description: 'Zbory CHWZ — это полнофункциональное приложение для управления и публичной презентации данных о собраниях CHWZ (Христианская Пятидесятническая Община). Оно сочетает интуитивный интерфейс с надёжным бэкендом для безопасного многопользовательского управления данными с облачной синхронизацией между устройствами.',
    },
    capabilities: {
      title: 'Ключевые возможности',
      multiUser: 'Многопользовательская платформа — безопасные учётные записи с аутентификацией и авторизацией',
      hybrid: 'Гибридная архитектура — локальные настройки в браузере, данные собраний в облаке',
      organization: 'Управление собраниями — профили, адреса, время богослужений и контактные лица',
      metadata: 'Статус публикации — черновик, опубликовано, требует проверки',
      portability: 'Контекст AI — описание приложения в формате Markdown для AI-ассистентов',
    },
    coreFeatures: {
      title: 'Основные функции',
      containers: {
        title: 'Профили собраний',
        multiple: 'Управление названием, описанием и статусом публикации собрания (черновик, опубликовано, непроверено)',
        hierarchical: 'Организационная иерархия — филиалы и регионы (в планах)',
        colors: 'Индикаторы статуса — быстрая идентификация состояния публикации и проверки',
        metadata: 'Метаданные собрания — описание, статус, настройки видимости',
        cycle: 'Процесс публикации и проверки данных собрания',
      },
      items: {
        title: 'Адреса и богослужения',
        rich: 'Данные адреса: улица, город, почтовый индекс, область, страна, статус публикации',
        categorization: 'Время богослужений — день и время встреч',
        status: 'Контактные лица — имя, должность, email и телефон ответственных лиц',
        priority: 'Несколько времён богослужений и контактных лиц на собрание',
        expiration: 'Валидация данных и обязательные поля для опубликованных профилей',
      },
      analytics: {
        title: 'Публичные представления',
        weight: 'Список собраний — публичный каталог с основной информацией',
        readiness: 'Детали собрания — адрес, время богослужений и контакты',
        charts: 'Панель администратора — управление пользователями и собраниями',
        statistics: 'Статистика — количество пользователей и опубликованных собраний',
      },
      search: {
        title: 'Поиск и фильтрация',
        smart: 'Поиск собраний по названию, городу или адресу',
        filtering: 'Фильтрация по статусу публикации и местоположению',
        sorting: 'Сортировка по названию или городу',
        expired: 'Выделение собраний, требующих проверки',
      },
      importExport: {
        title: 'Администрирование',
        json: 'Управление пользователями — роли, подтверждение email, 2FA',
        markdown: 'Управление собраниями — редактирование, публикация и снятие с публикации',
        csv: 'Панель администратора — обзор всех собраний и пользователей',
        crossDevice: 'Доступ с нескольких устройств — облачная синхронизация данных',
      },
    },
    businessFeatures: {
      title: 'Бизнес-функции',
      security: {
        title: 'Управление пользователями и безопасность',
        auth: 'Регистрация и вход пользователей — аутентификация email/пароль с безопасным хешированием паролей',
        oauth: 'OAuth социальный вход — вход через Google (поддержка GitHub запланирована)',
        email: 'Подтверждение email — подтверждение адресов электронной почты для безопасности учётной записи',
        '2fa': 'Двухфакторная аутентификация (2FA) — TOTP (приложения-аутентификаторы) и WebAuthn (ключи доступа/ключи безопасности)',
        password: 'Управление паролями — сброс забытых паролей, изменение пароля для аутентифицированных пользователей',
        recaptcha: 'Защита reCAPTCHA v3 — невидимая защита от ботов при входе, регистрации и сбросе пароля',
        session: 'Управление сессиями — JWT токены с автоматическим обновлением, безопасный выход',
        deletion: 'Удаление учётной записи — соответствующее GDPR мягкое удаление с подтверждением',
      },
      profile: {
        title: 'Профиль пользователя',
        management: 'Управление профилем — обновление имени, email и предпочтений',
        avatar: 'Поддержка аватара — OAuth провайдеры автоматически предоставляют фотографии профиля',
        settings: 'Предпочтительные настройки — язык, предпочтения темы',
        security: 'Настройки безопасности — управление методами 2FA, просмотр статуса безопасности',
      },
      i18n: {
        title: 'Многоязычная поддержка',
        languages: 'Английский, польский и русский полностью поддерживаются',
        detection: 'Автоматическое определение локали из браузера',
        switching: 'Ручное переключение языка в настройках',
        localized: 'Весь текст интерфейса, сообщения валидации и электронные письма локализованы',
      },
      theming: {
        title: 'Темизация',
        dark: 'Тёмный режим — полная поддержка тёмной темы с определением системных предпочтений',
        persistence: 'Сохранение темы — настройки сохраняются для каждой учётной записи пользователя',
      },
    },
    technical: {
      title: 'Технический стек',
      frontend: {
        title: 'Фронтенд',
      },
      backend: {
        title: 'Бэкенд',
      },
    },
  },
  aiContext: {
    title: 'Контекст AI',
    subtitle: 'Краткое описание Zbory CHWZ в формате Markdown для AI-ассистентов, таких как ChatGPT',
    card: {
      title: 'Скопировать контекст в буфер обмена',
      description: 'Нажмите кнопку ниже, чтобы скопировать описание контекста. Затем вы можете вставить его в ChatGPT или другие AI-ассистенты, чтобы предоставить контекст о Zbory CHWZ.',
    },
    copied: 'Контекст скопирован в буфер обмена',
  },
  personSearch: {
    personExists: 'Человек уже существует',
    unlink: 'Отвязать',
    editWarning: 'Редактирование доступно в разделе людей',
  },
  premium: {
    premiumFeature: 'Премиум функция',
    unlockPremiumFeatures: 'Разблокировать премиум функции — Обновитесь для доступа к AI-ассистенту и многому другому',
  },
}
